// extracted by mini-css-extract-plugin
module.exports = {"title":"comments-list-module--title--1tntP","customMedia":{},"customProperties":{},"customSelectors":{}};